import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import PrimaryGradientButton from "../../component/PrimaryGradientButton";
import PrimaryOutLineButton from "../../component/PrimaryOutLineButton";
import { Col, Container, Row } from "react-bootstrap";
import SelectDropDown from "../../component/SelectDropDown";
import UploadFile from "../../component/UploadFile";
import AlertMsg from "../../component/AlertMsg";
import InputField from "../../component/InputField";
import Button from "react-bootstrap/Button";
import DocumentImage from "../DocumentImage";
import { useNavigate } from "react-router-dom";
import OtherService from "../../services/Other";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { addMyConcentList } from "../../redux/slices/currentUserSlice";
import DOMPurify from "dompurify";
import { parseSafeHtml } from "../../utils/safeHtmlParser";

const ConsentModal = ({
  uploadImage,
  isButtonLoading,
  productConditionSelect,
  isLoginSuccessCondition,
  isLoginSuccessHeading,
  isLoginSuccessText,
  isLoginSuccess,
  showAlert,
  selectedStar,
  reasonValidationError,
  productImgValidationError,
  productImgTwoValidationError,
  colorChangeStarSelect,
  receiptValidationError,
  productConditionValidationError,
  experienceValidationError,
  complainImageTwo,
  setcomplainImageTwo,
  complainImage,
  setcomplainImage,
  setSelectedValue,
  selectedValue,
  isTextAreaVal,
  selectOptions,
  handleReasonChangeOnChange,
  onTextReviewChange,
  trackOrderData,
  onReviewSubmit,
  onClickOptionSelection,
  modalTitle,
  modalDescription,
  isModalOpen,
  setIsModalOpen,
  page,
  outlinebuttonText,
  onClick,
  serviceApproval,
  serviceRejectReasonData,
  serviceAcceptReasonData,
  isRejectReasonShow,
  setIsRejectReasonShow,
  isAcceptReasonShow,
  setIsAcceptReasonShow,
  handleApprove,
  handleRejectReasonOnChange,
  onHide = () => {},
}) => {
  const dispatch = useDispatch();
  const [showFileUpload, setShowFileUpload] = useState(false);
  const [receiptOrder, setReceiptOrder] = useState(false);
  const [consentValidationError, setConsentValidationError] = useState("");
  const [loading, setLoading] = useState(true);
  const [myOrderList, setMyOrderList] = useState([]);
  const [myConcentList, setMyConcentList] = useState([]);
  
  

  const navigate = useNavigate();
  

  const handleClose = () => {
    setIsModalOpen(false);
    onHide();
  };
  const formatDate = (date) => {
    const dateTime = new Date(date);
    return dateTime.toLocaleString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    });
  };

  const handleAcceptReason = () => {
    setIsAcceptReasonShow((prevState) => !prevState);
  };
  const handleReason = () => {
    setIsRejectReasonShow((prevState) => !prevState);
    // setIsAcceptReasonShow(prevState => !prevState);
  };

  const handleReasonBack = () => {
    setIsRejectReasonShow(false);
    setIsAcceptReasonShow(false);
  };

  useEffect(() => {
    setShowFileUpload(false);
    setReceiptOrder(false);
  }, [isModalOpen]);

  const onConsentSubmit = () => {
    // if (!myConsentValue) {
    //   setConsentValidationError('Please provide consent before proceeding.');
    //   return;
    // }
    setConsentValidationError("");
  };

    const loadOrders = async () => {
      try {
        setLoading(true);
        const res = await OtherService.myConsentList();
        if (JSON.stringify(res) != "{}" && !res.error) {
          setLoading(false);
          setMyOrderList(res.data);
        } else {
          setLoading(false);
        }
      } catch (error) {
        console.error("loadOrders error");
      }
    };
    useEffect(() => {
      loadOrders();
    }, []);

  async function onReceiveConsent(selectedValue) {
    try {
      setLoading(true);
      const payload = {
        "dcm_orders_id":selectedValue.order_id,
        "dcm_orders_item_id":selectedValue.item_id,
        "consent":selectedValue.title
      }
      
      const res = await OtherService.receivedConsent(payload);
      setLoading(false)
      if(res.data.status) {
        loadOrders();
        // setOpenDropdown(null);
        toast.show('', {
          data: {
            isSuccess: true,
            heading: res.data.message,
          },
        });
      }
    } catch(err) {
      setLoading(false);
    }
  }

  async function getConcentList () {
    try {
      setLoading(true);
      const res = await OtherService.concentOptionList();
      if(res.data.status) {
        dispatch(addMyConcentList({myConcentList: res.data.data}))
        setMyConcentList(res.data.data);
        setLoading(false)
      } else {
        setMyConcentList([]);
        setLoading(false);
      }
    } catch(err) {
      setLoading(false);
      
    }
  }

  useEffect(() => {
    if (page === "addconsent" || page === "myconsent") {
      getConcentList();
    }
  }, [page]);  

  return (
    <Modal show={isModalOpen} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{modalTitle}</Modal.Title>
      </Modal.Header>

      {/* {page === "consent" && (
        <Modal.Body>
          {!showAlert && (
            <div className="reviewForm"> */}
              {/* <div className="reviewFormBlockTitle">
                Please confirm your receipt <span className="redStar">*</span>
              </div> */}

              {/* <div className="consent-options" style={{ marginBottom: "20px" }}>
                <PrimaryOutLineButton
                  onClick={(selectedValue) => {
                    onReceiveConsent(selectedValue);
                  }}
                  outlinebuttonText="Yes, I have received"
                />
              </div>

              <div className="consent-options" style={{ marginBottom: "20px" }}>
                <PrimaryOutLineButton
                  onClick={() => {
                    navigate("/helpdesk")
                  }}
                  outlinebuttonText="Received, but damaged"
                />
              </div>

              <div className="consent-options"style={{ marginBottom: "20px" }}>
                <PrimaryOutLineButton
                  onClick={() => {
                    navigate("/helpdesk")
                  }}
                  outlinebuttonText="No, I haven’t received"
                />
              </div>

              {consentValidationError && (
                <div className="error-message">{consentValidationError}</div>
              )} */}

              {/* <div className="mt-3">
                <PrimaryGradientButton
                  buttonText="Submit"
                  onClick={() => {
                    if (!selectedValue) {
                      setConsentValidationError("Please select an option");
                      return;
                    }
                    onConsentSubmit(selectedValue);
                  }}
                />
              </div> */}
            {/* </div>
          )}
        </Modal.Body>
      )} */}

{/* {page === "consent" && (
  <Modal.Body>
    {!showAlert && (
      <div className="reviewForm">
        {myConcentList.length > 0 ? (
          myConcentList.map((option) => (
            <div className="consent-options" style={{ marginBottom: "20px" }} key={option.id}>
              <PrimaryOutLineButton
                onClick={() => {
                  if (option.redirectToHelpdesk) {
                    navigate("/helpdesk");
                  } else {
                    onReceiveConsent(option); 
                  }
                }}
                outlinebuttonText={option.name} 
              />
            </div>
          ))
        ) : (
          <p>No consent options available</p>
        )}

        {consentValidationError && (
          <div className="error-message">{consentValidationError}</div>
        )}
      </div>
    )}
  </Modal.Body>
)} */}
  {page === "addconsent" && (
    <Modal.Body>
      {!showAlert && (
        <div className="reviewForm">
          {myConcentList.length > 0 ? (
            myConcentList.map((option) => (
              <div
                className="consent-options"
                style={{ marginBottom: "20px" }}
                key={option.id}
              >
                <PrimaryOutLineButton
                  onClick={() => {
                    if (option.redirectToHelpdesk) {
                      navigate("/helpdesk");
                    } else {
                      onReceiveConsent(option);
                    }
                  }}
                  outlinebuttonText={option.name}
                />
              </div>
            ))
          ) : (
            <p>No consent options available</p>
          )}

          {consentValidationError && (
            <div className="error-message">{consentValidationError}</div>
          )}
        </div>
      )}
    </Modal.Body>
  )}

{page === "myconsent" && (
    <Modal.Body>
      {!showAlert && (
        <div className="reviewForm">
          {myConcentList.length > 0 ? (
            myConcentList.map((option) => (
              <div
                className="consent-options"
                style={{ marginBottom: "20px" }}
                key={option.id}
              >
                <PrimaryOutLineButton
                  onClick={() => {
                    if (option.redirectToHelpdesk) {
                      navigate("/helpdesk");
                    } else {
                      onReceiveConsent(option);
                    }
                  }}
                  outlinebuttonText={option.name}
                />
              </div>
            ))
          ) : (
            <p>No consent options available</p>
          )}

          {consentValidationError && (
            <div className="error-message">{consentValidationError}</div>
          )}
        </div>
      )}
    </Modal.Body>
  )}
{/* </Modal> */}

      {page == "cart" && (
        <Modal.Body>
          {/* <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(modalDescription) }}></div> */}
          <div>{parseSafeHtml(modalDescription)}</div>
        </Modal.Body>
      )}
      {page == "eventReadMore" && (
        <Modal.Body>
          {/* <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(modalDescription) }}></div> */}
          <div>{parseSafeHtml(modalDescription)}</div>
        </Modal.Body>
      )}
      {page == "trackOrder" && (
        <Modal.Body>
          <ul className="nprogress">
            {trackOrderData?.map((item, index) => {
              const orderStatusDate = formatDate(item.order_status_dt);
              return (
                <li
                  className="nprogress__item progress__item--active"
                  key={index}
                >
                  <p className="nprogress__title">
                    {item?.tracking_status == "Open"
                      ? "Order Placed"
                      : "Order Cancelled"}
                  </p>
                  <p className="nprogress__info">
                    {item?.tracking_status == "Open"
                      ? `Your Order has been placed. Online order Id: ${item?.dcm_order_id} `
                      : `Your Order has been cancelled. Online order Id: ${item?.dcm_order_id} `}
                  </p>
                  <p className="nprogress__info__date">
                    {" "}
                    {`Dated on ${orderStatusDate}`}
                  </p>
                </li>
              );
            })}
          </ul>
        </Modal.Body>
      )}
      {page === "reviewOrder" && (
        <Modal.Body>
          {!showAlert && (
            <div className="reviewForm">
              <div className="reviewFormBlockTitle">
                Overall Experience <span className="redStar">*</span>
              </div>
              <div className="reviewStar">
                <ul>
                  <li
                    onClick={() => {
                      onClickOptionSelection(0);
                    }}
                    className={selectedStar == 0 ? "selectedStar" : ""}
                  >
                    <span className="starImgReview "></span>
                    <span className="starImgReviewTxt">
                      Highly Dissatisfied
                    </span>
                  </li>
                  <li
                    onClick={() => {
                      onClickOptionSelection(1);
                    }}
                    className={selectedStar == 1 ? "selectedStar" : ""}
                  >
                    <span className="starImgReview"></span>
                    <span className="starImgReviewTxt">Dissatisfied</span>
                  </li>
                  <li
                    onClick={() => {
                      onClickOptionSelection(2);
                    }}
                    className={selectedStar == 2 ? "selectedStar" : ""}
                  >
                    <span className="starImgReview"></span>
                    <span className="starImgReviewTxt">Modarate</span>
                  </li>
                  <li
                    onClick={() => {
                      onClickOptionSelection(3);
                    }}
                    className={selectedStar == 3 ? "selectedStar" : ""}
                  >
                    <span className="starImgReview"></span>
                    <span className="starImgReviewTxt">Satisfied</span>
                  </li>
                  <li
                    onClick={() => {
                      onClickOptionSelection(4);
                    }}
                    className={selectedStar == 4 ? "selectedStar" : ""}
                  >
                    <span className="starImgReview"></span>
                    <span className="starImgReviewTxt">Highly Satisfied</span>
                  </li>
                </ul>
              </div>
              {experienceValidationError && (
                <div className="error-message pos-15">
                  {experienceValidationError}
                </div>
              )}
              <div className="reviewFormBlock">
                <div className="reviewFormBlockTitle">
                  Confirm receipt of order <span className="redStar">*</span>
                </div>
                <div className="reviewRadioWrap">
                  <div className="reviewRadio">
                    <label htmlFor="Yes" className="reviewFormBlockRadio">
                      Yes
                    </label>
                    <input
                      type="radio"
                      name="receiptConfirmation"
                      value="Yes"
                      onClick={() => {
                        onClickOptionSelection("Yes");
                        setReceiptOrder(true);
                      }}
                    />
                  </div>
                  <div className="reviewRadio">
                    <label htmlFor="No" className="reviewFormBlockRadio">
                      No
                    </label>
                    <input
                      type="radio"
                      name="receiptConfirmation"
                      value="No"
                      onClick={() => {
                        setReceiptOrder(false);
                        onClickOptionSelection("No");
                        setShowFileUpload(false);
                      }}
                    />
                  </div>
                </div>
              </div>
              {receiptValidationError && (
                <div className="error-message">{receiptValidationError}</div>
              )}
              <div className="reviewFormBlock mt-3">
                <div className="reviewFormBlockTitle">
                  Product condition <span className="redStar">*</span>
                </div>
                <div className="reviewRadioWrap">
                  <div className="reviewRadio">
                    <label htmlFor="Good" className="reviewFormBlockRadio">
                      Good
                    </label>
                    <input
                      disabled={!receiptOrder}
                      type="radio"
                      name="productCondition"
                      value="Good"
                      onClick={() => {
                        onClickOptionSelection("Good");
                        setShowFileUpload(false);
                      }}
                    />
                  </div>
                  <div className="reviewRadio">
                    <label htmlFor="Bad" className="reviewFormBlockRadio">
                      Bad
                    </label>
                    <input
                      disabled={!receiptOrder}
                      type="radio"
                      name="productCondition"
                      value="Bad"
                      onClick={() => {
                        onClickOptionSelection("Bad");
                        setShowFileUpload(true);
                      }}
                    />
                  </div>
                </div>
              </div>
              {productConditionValidationError && (
                <div className="error-message">
                  {productConditionValidationError}
                </div>
              )}
              {showFileUpload && (
                <div className="mt-2 mb-4">
                  <SelectDropDown
                    labelName="Reason"
                    requiredStar="*"
                    options={selectOptions}
                    setSelectedValue={setSelectedValue}
                    selectedValue={selectedValue}
                    onChange={handleReasonChangeOnChange}
                  />

                  {productConditionSelect == "Bad" && reasonValidationError && (
                    <div className="error-message">{reasonValidationError}</div>
                  )}
                  <div>
                    <UploadFile
                      label="Upload Image"
                      requiredStar="*"
                      accept="image/*"
                      value={complainImage}
                      setValue={setcomplainImage}
                    />
                    {productConditionSelect == "Bad" &&
                      productImgValidationError && (
                        <div className="error-message pos-3">
                          {productImgValidationError}
                        </div>
                      )}
                    <UploadFile
                      label="Upload Image"
                      requiredStar="*"
                      accept="image/*"
                      value={complainImageTwo}
                      setValue={setcomplainImageTwo}
                    />
                    {productConditionSelect == "Bad" &&
                      productImgTwoValidationError && (
                        <div className="error-message pos-3">
                          {productImgTwoValidationError}
                        </div>
                      )}
                  </div>
                  {/* <p>Preview Upload Image</p> */}
                  {/* {complainImage && (
                    // <img
                    //   src={complainImage.file}
                    //   alt="Complain Image"
                    //   style={{ maxWidth: "100%", maxHeight: "200px" }}
                    // />
                    <DocumentImage imageUrl={complainImage.file} title='Complain Image' />
                  )}
                  {complainImageTwo && (
                    // <img
                    //   src={complainImageTwo.file}
                    //   alt="Complain Image"
                    //   style={{ maxWidth: "100%", maxHeight: "200px" }}
                    // />
                    <DocumentImage imageUrl={complainImageTwo.file} title='Complain Image' />
                  )} */}
                </div>
              )}
              <div className="reviewFormBlock mt-3">
                <div className="reviewFormBlockTitle">Other Sugggestion</div>
                <div className="reviewRadioWrap">
                  <div className="reviewTxt">
                    <textarea
                      name="suggestionText"
                      className="form-control"
                      onChange={onTextReviewChange}
                      value={isTextAreaVal}
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* {showAlert &&
            <Col xs={12} className='mt-3'>
              <AlertMsg alertBoxColor={isLoginSuccessCondition ? 'successAlert' : 'FailedAlert'}
                heading={isLoginSuccessHeading}
                text={isLoginSuccessText} />

            </Col>
          } */}
        </Modal.Body>
      )}
      {page == "documentLibraryImageModal" && (
        <Modal.Body>
          {/* <img src={uploadImage.file} alt='image' className='img-fluid' /> */}
          <DocumentImage imageUrl={uploadImage.file} title="Document Image" />
        </Modal.Body>
      )}
      {page !== "reviewOrder" && page !== "myService" && page !== "addconsent" && (
        <Modal.Footer>
          <Container>
            <Row className="justify-content-center">
              <Col xs={12} md={6}>
                <PrimaryGradientButton
                  buttonText="Close"
                  onClick={handleClose}
                />
              </Col>
              {page == "cart" && (
                <Col xs={12} md={6}>
                  <PrimaryOutLineButton
                    outlinebuttonText={outlinebuttonText}
                    onClick={onClick}
                  />
                </Col>
              )}
            </Row>
          </Container>
        </Modal.Footer>
      )}
      {page == "reviewOrder" && (
        <Modal.Footer>
          <Container>
            {!showAlert && (
              <Row className="justify-content-center">
                <Col xs={12} md={6}>
                  <PrimaryGradientButton
                    buttonText={isButtonLoading ? "Processing..." : "Submit"}
                    onClick={onReviewSubmit}
                    disabled={isButtonLoading}
                  />
                </Col>
              </Row>
            )}
          </Container>
        </Modal.Footer>
      )}

      {page == "myService" && (
        <>
          <Modal.Body>
            <div className="myServiceModal">
              <InputField
                inputFieldLabel="Transaction Id"
                name="service_id"
                value={serviceApproval.service_id}
                editable={false}
              />

              <InputField
                // requiredStar="*"
                inputFieldLabel="Customer Name"
                name="customerName"
                value={serviceApproval.customer_name}
                // onChange={}
                editable={false}
              />

              <InputField
                inputFieldLabel="Customer Mobile"
                name="customerName"
                value={serviceApproval.mobile}
                editable={false}
              />

              <InputField
                inputFieldLabel="Service Name"
                name="customerName"
                value={serviceApproval.product_description}
                editable={false}
              />
              {isRejectReasonShow && (
                <SelectDropDown
                  labelName="Reject Reason"
                  requiredStar="*"
                  options={serviceRejectReasonData}
                  setSelectedValue={setSelectedValue}
                  selectedValue={selectedValue}
                  onChange={handleRejectReasonOnChange}
                />
              )}

              {isAcceptReasonShow && (
                <SelectDropDown
                  labelName="Accept Reason"
                  requiredStar="*"
                  options={serviceAcceptReasonData}
                  setSelectedValue={setSelectedValue}
                  selectedValue={selectedValue}
                  onChange={handleRejectReasonOnChange}
                />
              )}
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Container className="p-0">
              {!(isRejectReasonShow || isAcceptReasonShow) && (
                <Row className="justify-content-center">
                  <Col xs={12} md={6}>
                    <Button variant="danger w-100" onClick={handleReason}>
                      Reject
                    </Button>
                  </Col>
                  <Col xs={12} md={6}>
                    <Button
                      variant="success w-100"
                      onClick={handleAcceptReason}
                    >
                      Approve
                    </Button>
                  </Col>
                </Row>
              )}
              {(isRejectReasonShow || isAcceptReasonShow) && (
                <Row className="justify-content-center">
                  <Col xs={12} md={6}>
                    <PrimaryOutLineButton
                      outlinebuttonText="Back"
                      onClick={handleReasonBack}
                    />
                  </Col>
                  <Col xs={12} md={6}>
                    {isRejectReasonShow && (
                      <PrimaryGradientButton
                        buttonText="Submit"
                        onClick={() => handleApprove("reject")}
                      />
                    )}
                    {isAcceptReasonShow && (
                      <PrimaryGradientButton
                        buttonText="Submit"
                        onClick={() => handleApprove("accept")}
                      />
                    )}
                  </Col>
                </Row>
              )}
            </Container>

            {showAlert && (
              <Col xs={12} className="mt-3">
                <AlertMsg
                  alertBoxColor={
                    isLoginSuccessCondition ? "successAlert" : "FailedAlert"
                  }
                  heading={isLoginSuccessHeading}
                  text={isLoginSuccessText}
                />
              </Col>
            )}
          </Modal.Footer>
        </>
      )}
    </Modal>
  );
};

export default ConsentModal;
